import React from 'react';

import { Grid, Hidden } from '@material-ui/core';

import ContestSelectorItem from './ContestSelectorItem/ContestSelectorItem';
import { useContestSetupState } from '../Context/ContestSetup.context';

export const ContestSelector: React.FunctionComponent = () => {
  const { contestSelectorOptions } = useContestSetupState();

  return (
    <Hidden smDown={true}>
      <Grid className="grid-item left" item={true} xs={12} md={4}>
        <h3>CONTESTS</h3>

        {contestSelectorOptions.map(contestSelectorOption => (
          <ContestSelectorItem
            key={`${contestSelectorOption.value.metaFormat.id}-${
              contestSelectorOption.value.scoreType
            }`}
            contestSelectorOption={contestSelectorOption}
          />
        ))}
      </Grid>
    </Hidden>
  );
};

export default ContestSelector;
